var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgFinalAssigScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "task-assignment-task-homework-assignment-svgrepo-com",
    d: "M9.857,4.429A3.452,3.452,0,1,1,6.41,7.889,3.443,3.443,0,0,1,9.857,4.429Zm9.786,14.524H15.322l2.017-3.476a1.505,1.505,0,1,0-2.605-1.508l-2.017,3.476-3-5.143a1.665,1.665,0,0,0-1.573-.81,2.012,2.012,0,0,0-.413.063c-.1.016-.238.063-.349.1C4.488,12.6,2.2,17.222,2.2,22h8.689c-.064-.1-.127-.175-.191-.27l-3.479-6a.43.43,0,0,1,.747-.429l3.447,5.952A1.476,1.476,0,0,0,12.7,22h6.942a1.524,1.524,0,0,0,0-3.048ZM15.824,2a.746.746,0,1,1-.746.746A.746.746,0,0,1,15.824,2Zm1.163.173H22.2V3.315H16.987ZM15.824,4.5a.746.746,0,1,1-.746.746A.746.746,0,0,1,15.824,4.5Zm1.163.173H22.2V5.812H16.987ZM15.824,6.995a.746.746,0,1,1-.746.746A.746.746,0,0,1,15.824,6.995Zm1.163.176H22.2V8.313H16.987Z",
    transform: "translate(-2.2 -2)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgFinalAssigScore);
export default __webpack_public_path__ + "static/media/avg-final-assig-score.9ffb8fbc36719bfdf4abeb64a3bd1c02.svg";
export { ForwardRef as ReactComponent };